export var logoutEventName = "vis-logout";
export var loginEventName = "vis-login";
export var loginEvent = function loginEvent() {
  return window.localStorage.setItem(loginEventName, Date.now());
};
export var logoutEvent = function logoutEvent() {
  return window.localStorage.setItem(logoutEventName, Date.now());
};